import { META } from '../types';
export default {
  type: META,
  service: 'api.metadium.com',
  url: 'https://api.metadium.com/prod',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
